import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=58d84e19&scoped=true&"
import script from "./AuthLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLayout.vue?vue&type=script&lang=js&"
import style1 from "./AuthLayout.vue?vue&type=style&index=1&id=58d84e19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d84e19",
  null
  
)

export default component.exports